import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { map, catchError, finalize } from "rxjs/operators";
import { GlobalConstants } from "../../meeting-manager/lib/global-constants";
import { Constants } from "../../meeting-manager/lib/constants";
import { LoaderService } from "../../shared/services/loader.service";
import { throwError, Observable } from "rxjs";
import { SnackbarService } from "../../meeting-manager/lib/services/snackbar.service";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  counter = 0;
  constructor(
    public globalConstants: GlobalConstants,
    public constants: Constants,
    private loaderService: LoaderService,
    private snackbarService: SnackbarService,
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.loaderService.show();
    let tokenAuth: HttpRequest<any>;
    this.counter++;
    tokenAuth = request.clone({
      setHeaders: {
        "Content-Type": "application/json",
      },
    });

    return next.handle(tokenAuth).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        const data = { error: "", status: 500 };
        if (
          error &&
          error.error &&
          error.error instanceof Blob &&
          error.status === 400
        ) {
          this.parseBlobErrMsg(error.error);
        } else if (error && error.error && error.error.length) {
          if (typeof error.error === "string") {
            data.error = error.error;
          } else {
            data.error = error.error[0];
          }
        } else if (error?.status === 401) {
          data.error = this.constants.messages.error.unauthorizedAccess;
        } else {
          data.error = this.constants.messages.error.internalServerError;
        }
        data.status = error.status;
        if (data.status === 401 || data.status === 404 || data.status === 500) {
          this.snackbarService.showMessage(data.error);
        }
        if (data.status === 428) {
          data.error = this.constants.messages.error.unsafeHtml;
          this.snackbarService.showMessage(
            this.constants.messages.error.unsafeHtml,
          );
        }
        return throwError(data);
      }),
      finalize(() => {
        this.counter--;
        if (this.counter === 0) {
          this.loaderService.hide();
        }
      }),
    );
  }
  parseBlobErrMsg(error: Blob) {
    let reader = new FileReader();
    reader.onload = (e: Event) => {
      const errmsg = JSON.parse((<any>e.target).result);
      this.snackbarService.showMessage(errmsg);
    };
    reader.readAsText(error);
  }
}
